import { gql } from "@apollo/client";

const ACCEPT_MOBILITY = gql`
  mutation acceptMobility($shortTermID: String!, $email: String!, $name: String!, $position: String!, $institution: Int!) {
    acceptMobility(shortTermID: $shortTermID, email: $email, name: $name, position: $position, institution: $institution) 
  }
`;

export default ACCEPT_MOBILITY;
